import Bugsnag from '@bugsnag/js';
import getCsrfToken from '@99designs/frontend-components/utils/app/getCsrfToken';
import { HttpError } from '@99designs/apps/spa/pages/auth/HttpError';

const fetchPreAuthorisation = (search: string) => {
    const csrfToken = getCsrfToken();
    if (!csrfToken) {
        return Promise.reject(new Error('Missing CSRF token'));
    }

    const params = new URLSearchParams(search);
    params.append('csrf_token', csrfToken);
    const paramString = params.toString();

    return fetch(`/accounts/xhr/pre-auth?${paramString.toString()}`, {
        method: 'GET',
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
    })
        .then((response) => {
            if (response.status === 200) {
                return response.json();
            }
            return Promise.reject(new HttpError(response.status.toString(), response.statusText));
        })
        .catch((e) => {
            Bugsnag.notify(e, (event) => {
                event.context = 'pre authorisation';
            });
            return Promise.reject(e);
        });
};

export default fetchPreAuthorisation;
